// extracted by mini-css-extract-plugin
export default {"ratingSelect":"RatingSelect-index__ratingSelect--wssmb","cardRatingSelect":"RatingSelect-index__cardRatingSelect--j7XAf"};